import {
    NotificationProvider as RefineNotificationProvider,
    OpenNotificationParams,
} from '@refinedev/core';
import { notification } from 'antd';

let currentErrorKey: string | null = null;

export const notificationProvider: RefineNotificationProvider = {
    open: ({
        key,
        message,
        description,
        type = 'progress',
    }: OpenNotificationParams) => {
        const antdType = type === 'progress' ? 'info' : type;
        let resolvedKey = key;

        if (antdType === 'error') {
            resolvedKey = resolvedKey ?? 'global-error-notification';

            if (currentErrorKey && currentErrorKey !== resolvedKey) {
                notification.destroy(currentErrorKey);
            }

            currentErrorKey = resolvedKey;
        }

        notification.open({
            key: resolvedKey,
            message: message as string,
            description: description as string | undefined,
            type: antdType as 'success' | 'error' | 'info' | 'warning',
            className: 'custom-notification',
        });
    },
    close: (key: string) => {
        notification.destroy(key);
        if (currentErrorKey === key) {
            currentErrorKey = null;
        }
    },
};
